<div style="height: 25px;"></div>
<mat-drawer-container style = "background-color: white !important;">
  <mat-drawer-content style = "background-color: white !important;">
    @if (showSpinner || training == null || user == null || labels == null || progress == null || currentUnit == null) {
      <app-user-spinner style="z-index: 2000;">
        <mat-spinner class="spinner" [color] = "spinnerColor"></mat-spinner>
      </app-user-spinner>
    }
    <div class="container d-sm-flex">
      <div class="container2">
        @if (currentUnit.videoPath == null) {
          <div class = "goToTrainingDetailsNavy" (click) = "goToTrainingDetails(training)">
            <img src = "./assets/icons/backIconNavy.png" alt = "Back icon image">
            <span style = "vertical-align: middle; padding-left: 11px;">{{training.name}}</span>
          </div>
        }
        @if ((currentUnit.imagePath != null) && (showControl == false)) {
          <div class="imgCls" style="width: 100%; height: 70vh">
            <img src={{imagePath}} alt = "unit image" style="margin: auto; width: 100%; height: 100%;  object-fit: contain;">
          </div>
        }
        @if (currentUnit.videoPath != null) {
          <div class="playerContainer" [class]="playerClass" style="position: relative; ">
            <div class = "goToTrainingDetails" (click) = "goToTrainingDetails(training)">
              <img src = "./assets/icons/backIconWhite.png" alt = "Back icon image">
              <span style = "vertical-align: middle; padding-left: 11px;">{{training.name}}</span>
            </div>
            <div  class="arrowContainer" [class] = "pausePlayHover">
              <div class={{arrowBackClass}} (click)="onPreviousVideo()" style = "vertical-align: middle;">
                <img src = "./assets/icons/prevVideoIconWhite.png" alt = "Back arrow image">
              </div>
              <div class="playPuseBtn" style = "vertical-align: middle;">
                <mat-icon (click)="playPauseVideo()" [inline]="true" style = "vertical-align: middle;">{{playPauseBtn}}</mat-icon>
              </div>
              <div class="arrowForward" (click)="onNextVideo()" style = "vertical-align: middle;">
                <img src = "./assets/icons/nextVideoIconWhite.png" alt = "Next arrow image">
              </div>
            </div>
            <!-- da se disabl-uje speed rate i pic in pic: disablepictureinpicture; controlsList="nodownload noplaybackrate" -->
            <video [class] = "videoTransparent" id="my-video" #player controls width="100%" height="100%" src={{videoPath}} type="video/mp4"
              (ended)="onVideoFinished()" (play)="setPauseIcon()" (pause)="setPlayIcon()" controlsList="noplaybackrate nodownload"
              (seeking)="onSeeking()" (timeupdate)="onTimeUpdate()" (contextmenu)="onContextMenu($event)">
            </video>
          </div>
        }
        @if (currentUnit.audioPath != null) {
          <div [class]="playerClass" style="margin-bottom: 15px; margin-top: 3%;">
            <div style = "margin: auto;">
              <div class = "col-12" style = "margin: auto; text-align: center;">
                <img src = "./assets/icons/audioUnitIcon.png" alt = "Audio unit image">
              </div>
              <div class = "col-12" style = "margin: auto; text-align: center;">
                <img style = "width: 40px; margin: 45px; cursor: pointer;" (click) = "onPreviousVideo()" src = "./assets/icons/audioPrev.png" alt = "Previous unit image">
                @if (audioPlayBtn) {
                  <img class = "audioPlayBtn" style = "cursor: pointer;" (click) = "playAudioUnit(currentUnit.audioPath)" src = "./assets/icons/playUnitIcon.png" alt = "Play audio unit">
                }
                @if (audioPauseBtn) {
                  <mat-icon style = "width: 75px; height: 75px; vertical-align: middle; font-size: 75px;" (click) = "pauseAudioUnit()">pause</mat-icon>
                }
                <img style = "width: 40px; margin: 40px; cursor: pointer;" (click) = "onNextVideo3(1)" src = "./assets/icons/audioNext.png" alt = "Next unit image">
              </div>
            </div>
            <!-- <ngx-audio-player [playlist]="playlist" style="width: 100%" [displayTitle]="false" [autoPlay]="false"
            muted="muted" [displayPlaylist]="false"
            [displayDuration]="false"
            [expanded]="true" (trackEnded)="onEnded($event)" [displayVolumeControls]="true" [displayRepeatControls]="true"
          [disablePositionSlider]="true"></ngx-audio-player>    -->
        </div>
      }

      @if (currentUnit.documentPath != null) {
        <div class = "row" [class] = "playerClass"  style="margin-bottom: 15px; margin-top: 3%;">
          <div class = "col-12" style = "margin: auto; text-align: center;">
            <a href="{{documentPath}}" (click) = "docDownloaded()" target="_blank">
              <img src = "./assets/icons/docUnitIcon.png" alt = "Document unit image">
              <p style="padding-top: 30px">{{labels.downloadBeforeProceeding}}</p>
            </a>
          </div>
          <div class = "col-12" style = "margin: auto; text-align: center;">
            <img style = "width: 40px; margin: 45px; cursor: pointer; margin-right: 85px;" (click) = "onPreviousVideo()" src = "./assets/icons/audioPrev.png" alt = "Previous unit image">
            <img style = "width: 40px; margin: 40px; cursor: pointer; margin-left: 85px;" (click) = "onNextVideo3(2)" src = "./assets/icons/audioNext.png" alt = "Next unit image">
          </div>
        </div>
      }

      @if (currentUnit.text != null && currentUnit.videoPath == null && currentUnit.audioPath == null && currentUnit.imagePath == null && currentUnit.documentPath == null) {
        <div [class] = "playerClass"  style="overflow-y: auto; margin: 3% auto 15px">
          <div style = "height: 45vh; text-align: center;">
            @if (text) {
              <div>
                @for (line of text.split('\n'); track line) {
                  <div>
                    <h5 style = "font-family: Lato, 'Alegreya'; font-size: 21px; color: #0E0D35; opacity: 0.5;">{{line}}</h5>
                    <br /> <!-- Add a line break after each line -->
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      <div class = "row" style = "width: 100%; margin: auto;">
        <div class="progress" [style.width]="progress+'%'"></div>
      </div>

      <div class = "row">
        @if (showText && currentUnit.text != null && (currentUnit.videoPath != null || currentUnit.audioPath != null || currentUnit.imagePath != null || currentUnit.documentPath != null)) {
          <div class = "col-12">
            <h5 style = "font-family: Lato, 'Alegreya'; font-size: 21px; color: #0E0D35; opacity: 0.5;">{{text}}</h5>
          </div>
        }
        <div class = "col-12" style = "width: 100%;">
          <div class = "sectionName font" style = "width: 100%;">
            <span style="width: 90%; display: table-cell; padding: 15px; line-height: 30px; font-size: 33px; color: #0E0D35">
            {{currentUnit.order}} {{currentUnit.name}}</span>
            <!--<span style = "width: 10%;">
              @if (!showText) {
                <mat-icon (click) = "toggleUnitMessage()" style = "vertical-align: middle; cursor: pointer; color: #0E0D35;">expand_more</mat-icon>
              }
              @if (showText) {
                <mat-icon (click) = "toggleUnitMessage()" style = "vertical-align: middle; cursor: pointer; color: #0E0D35;">expand_less</mat-icon>
              }
            </span>-->
          </div>
          <div style = "width: 100%;">
            {{labels.lblSection}}:<span style = "color: #0E0D35; font-size: 17px; font-weight: normal; margin-left: 10px;"> {{training.name}}</span>
          </div>
        </div>
      </div>

      <!-- <mat-accordion>
      <mat-expansion-panel  class = "expansionPanel2">
        <mat-expansion-panel-header>
          <mat-expansion-title>
            <div class = "sectionName font" style = "width: 100%;">
              <span style="display:table-cell; padding: 15px; line-height: 30px; font-size: 33px; color: #0E0D35">
              {{currentUnit.order}} {{currentUnit.name}}</span>
            </div>
            <div style = "width: 100%;">
              <span style = "color: #0E0D35; font-size: 17px; font-weight: normal; margin-left: 35px;"> {{currentUnit.sectionName}}</span>
            </div>
          </mat-expansion-title>
        </mat-expansion-panel-header>
        <div style = "margin-top: 3%;" *ngIf = "currentUnit.text != null" [class]="playerClass">
          <p style="font-family: Lato, 'Alegreya Sans'; color: #0E0D35; padding: 11px; font-size: 2.3vh; opacity: 0.5; word-break: break-word;">{{text}}</p>
        </div>
      </mat-expansion-panel>
    </mat-accordion> -->

    <!-- <mat-accordion class="example-headers-align">
    <mat-expansion-panel style="margin-top: 10px; padding-top: 10px;" class = "expansionPanel2">
      <mat-expansion-panel-header style = "padding-left: 0px;">
        <mat-panel-title>
          <div class = "row" class = "sectionName font">
            <div class = "col-12">
              <span style="display:table-cell; padding: 15px; line-height: 30px; font-size: 33px; color: #0E0D35">
              {{currentUnit.order}} {{currentUnit.name}}</span>
            </div>
            <div class = "col-12">
              <span style = "color: #0E0D35; font-size: 17px; font-weight: normal; margin-left: 35px;"> {{currentUnit.sectionName}}</span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngIf = "currentUnit.text != null" [class]="playerClass" style="margin-bottom: 15px;">
        <div class="col-12 textUnit" style="width: 100%; height: 100%;font-family: Lato, 'Alegreya Sans'; color: #0E0D35; padding: 11px; font-size: 2.3vh; opacity: 0.5;"><p>{{text}}</p></div>
      </div>
    </mat-expansion-panel>
  </mat-accordion> -->

  <!-- WEB ROW -->
  <div class = "row webVisible" style = "padding-top: 3%; padding-bottom: 3%; border-top: 1px solid #e6e6e6; border-bottom: 1px solid #e6e6e6;">
    <div class = "col-3">
      <div class = "row">
        <div class = "col-12" style = "display: flex; margin-top: 10px; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16px; ">
          <div>
            <img style = "width: 50px; border-radius: 11px;" src="{{trainer.profileImagePath}}" alt = "Trainer profile image">
          </div>
          <div style = "padding-left: 10px; font-size: 16px;font-family: Lato, 'Alegreya Sans'; text-align: left;">
            {{trainer?.firstName}} {{trainer?.lastName}}<br>
             <p style = "font-size: 14px; color: #799ACF">{{trainer.email}}</p>
          </div>
        </div>
      </div>
      @for (coTrainer of coTrainers; track coTrainer) {
        <div class = "row">
          <div class = "col-12" style = "display: flex; margin-top: 10px; text-align: center; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16px; " matTooltip="{{coTrainer.about}}"
            matTooltipClass="about-author">
            <div>
              <img style = "width: 50px; border-radius: 11px;" src="{{coTrainer.profileImagePath}}" alt = "Trainer profile image">
            </div>
            <div style = "padding-left: 10px; word-break: break-all; font-size: 16px;font-family: Lato, 'Alegreya Sans'; text-align: left;">
              {{coTrainer?.firstName}} {{coTrainer?.lastName}}<br>
              <!-- <span style = "font-size: 14px; color: #799ACF">{{trainer.email}}</span> -->
            </div>
          </div>
        </div>
      }
    </div>
    <div class = "col-6">
      <div class = "row">
        <div class = "col-3 training-data-button" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
          (click)="whatToDisplay('training')">
          <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              @if (!trngClicked) {
                <img style = "width: 20px" src = "./assets/icons/trngIconGrey.png" alt = "Training icon">
              }
              @if (trngClicked) {
                <img style = "width: 20px" src = "./assets/icons/trngIconGreen.png" alt = "Training icon">
              }
            </div>
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              <h5 [style.color] = "color3" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblNumOfUnits}}</h5>
            </div>
          </div>
        </div>
        @if (training.allowComments) {
          <div class = "col-3" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
               (click)="whatToDisplay('comments')">
            <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
              <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                @if (!clickedComment) {
                  <img style = "width: 20px" src = "./assets/icons/forumGrey.png" alt = "Comment icon">
                }
                @if (clickedComment) {
                  <img style = "width: 20px" src = "./assets/icons/forumGreen.png" alt = "Comment icon">
                }
              </div>
              <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
                <h5 [style.color] = "color1" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblComments}}</h5>
              </div>
            </div>
          </div>
        }

        <div class = "col-3" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
          (click)="whatToDisplay('documents')">
          <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              @if (!clickedCouments) {
                <img style = "width: 20px" src = "./assets/icons/docIconGrey.png" alt = "Document icon">
              }
              @if (clickedCouments) {
                <img style = "width: 20px" src = "./assets/icons/docIconGreen.png" alt = "Document icon">
              }
            </div>
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              <h5 [style.color] = "color2" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblDocuments}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class = "col-3" style = "text-align: right;">
      <div style = "display: inline-block; padding-right: 50px;">
        @if (currentUnit.order == 1) {
          <img style = "width: 24px; margin-top: 20px;" src = "./assets/icons/prevIconGrey.png" alt = "Previous icon">
        }
        @if (currentUnit.order != 1) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onPreviousVideo()"  src = "./assets/icons/prevIconNavy.png" alt = "Previous icon">
        }
      </div>
      <div style = "display: inline-block;">
        @if (currentUnit.videoPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;"  (click) = "onNextVideo()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.imagePath != null) {
          <img style = "cursor: pointer; margin-top: 20px;"  (click) = "onNextVideo2()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.audioPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo3(1)" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.documentPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo3(2)" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if ((currentUnit.text != null) && (currentUnit.videoPath == null) && (currentUnit.audioPath == null) && (currentUnit.imagePath == null) && (currentUnit.documentPath == null)) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo2()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
      </div>
    </div>
  </div>

  <!-- MOB ROW -->
  <div class = "row mobVisible" style = "margin-top: 3%;">
    <div class = "col-6">
      <div class = "row">
        <div class = "col-12" style = "display: flex; margin-top: 10px; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16px; ">
          <div>
            <img style = "width: 50px; border-radius: 11px;" src = "{{trainer?.profileImagePath}}" alt = "Trainer profile image">
          </div>
          <div style = "padding-left: 10px; word-break: break-all; font-size: 16px;font-family: Lato, 'Alegreya Sans'; text-align: left;">
            {{trainer?.firstName}} {{trainer?.lastName}}<br>
            <!-- <span style = "font-size: 14px; color: #799ACF">{{trainer.email}}</span> -->
          </div>
        </div>
      </div>
      @for (coTrainer of coTrainers; track coTrainer) {
        <div class = "row">
          <div class = "col-12" style = "display: flex; margin-top: 10px; color: #0E0D35;font-family: Lato, 'Alegreya Sans'; font-weight: normal; font-size: 16px; ">
            <div>
              <img style = "width: 50px; border-radius: 11px;" src = "{{coTrainer?.profileImagePath}}" alt = "Trainer profile image">
            </div>
            <div style = "padding-left: 10px; word-break: break-all; font-size: 16px;font-family: Lato, 'Alegreya Sans'; text-align: left;">
              {{coTrainer?.firstName}} {{coTrainer?.lastName}}<br>
              <!-- <span style = "font-size: 14px; color: #799ACF">{{trainer.email}}</span> -->
            </div>
          </div>
        </div>
      }
    </div>
    <div class = "col-6" style = "text-align: right;">
      <div style = "display: inline-block; padding-right: 50px;">
        @if (currentUnit.order == 1) {
          <img style = "width: 24px; margin-top: 20px;" src = "./assets/icons/prevIconGrey.png" alt = "Previous icon">
        }
        @if (currentUnit.order != 1) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onPreviousVideo()"  src = "./assets/icons/prevIconNavy.png" alt = "Previous icon">
        }
      </div>
      <div style = "display: inline-block;">
        @if (currentUnit.videoPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;"  (click) = "onNextVideo()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.imagePath != null) {
          <img style = "cursor: pointer; margin-top: 20px;"  (click) = "onNextVideo2()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.audioPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo3(1)" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if (currentUnit.documentPath != null) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo3(2)" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
        @if ((currentUnit.text != null) && (currentUnit.videoPath == null) && (currentUnit.audioPath == null) && (currentUnit.imagePath == null) && (currentUnit.documentPath == null)) {
          <img style = "cursor: pointer; margin-top: 20px;" (click) = "onNextVideo2()" src = "./assets/icons/nextIconNavy.png" alt = "Next icon">
        }
      </div>
    </div>
    <div class = "col-12" style = "margin-top: 5%;">
      <div class = "row">
        <div class = "col-3" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
          (click)="whatToDisplay('training')">
          <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              @if (!trngClicked) {
                <img style = "width: 20px" src = "./assets/icons/trngIconGrey.png" alt = "Training icon">
              }
              @if (trngClicked) {
                <img style = "width: 20px" src = "./assets/icons/trngIconGreen.png" alt = "Training icon">
              }
            </div>
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              <h5 [style.color] = "color3" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblNumOfUnits}}</h5>
            </div>
          </div>
        </div>
        @if (training.allowComments) {
        <div class = "col-3" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
          (click)="whatToDisplay('comments')">
          <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              @if (!clickedComment) {
                <img style = "width: 20px" src = "./assets/icons/forumGrey.png" alt = "Comment icon">
              }
              @if (clickedComment) {
                <img style = "width: 20px" src = "./assets/icons/forumGreen.png" alt = "Comment icon">
              }
            </div>
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              <h5 [style.color] = "color1" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblComments}}</h5>
            </div>
          </div>
        </div>
        }
        <div class = "col-3" style = "background: #FFFFFF;
          -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
          border-radius: 24px; margin: auto; padding: 10px; cursor: pointer"
          (click)="whatToDisplay(currentUnit.documentPath == null ? 'documents' : 'docUnit')">
          <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              @if (!clickedCouments) {
                <img style = "width: 20px" src = "./assets/icons/docIconGrey.png" alt = "Document icon">
              }
              @if (clickedCouments) {
                <img style = "width: 20px" src = "./assets/icons/docIconGreen.png" alt = "Document icon">
              }
            </div>
            <div class = "col-12" style = "width: 100%; margin: auto; text-align: center;">
              <h5 [style.color] = "color2" style = "font-family: Lato, 'Alegreya Sans'; font-size: 15px;">{{labels.lblDocuments}}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- KOMENTARI -->
@if (training.allowComments) {
  <div [style.display]="displayComments" class = "row" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px;">
    <div style="width: 100%; margin: auto; margin-bottom: 15px;">
      <div>
        <h2 class="text-center">
          {{labels.lblComments}}
        </h2>

      </div>
      <div style="width: 100%; margin: auto; background: #FFFFFF;
                   -webkit-box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07); box-shadow: 0px 8px 25px rgba(83, 89, 144, 0.07);
                    border-radius: 16px;font-family: Lato, 'Alegreya Sans' !important;">
        <form (ngSubmit)="submitComment()" #insertForm="ngForm" style="width: 100%; margin: auto">
          <div style = "width: 90%; display: inline-block;">
            <input matInput [ngModel]="user._id" name="userId" hidden>
            <input matInput [ngModel]="user.firstName" name="firstName" hidden>
            <input matInput [ngModel]="user.lastName" name="lastName" hidden>
            <input matInput [ngModel]="user.email" name="email" hidden>
            <mat-form-field appearance="none" style="width:100%; margin: auto; color: #0E0D35 !important;">
                                <textarea matInput ngModel name="text" placeholder="{{labels.lblComment}}" style="font-size: 17px; color: #0E0D35 !important; font-family: Lato, 'Alegreya Sans' !important; padding-top: 5px !important;
                                padding-left: 10px !important;"></textarea>
            </mat-form-field>
          </div>
          <div style = "width: 10%; display: inline-block; text-align: center">
            <img style = "cursor: pointer; padding-bottom: 20px;" (click) = "submitComment()" src = "./assets/icons/sendComment.png" alt = "Send comment icon">
          </div>
        </form>
      </div>
      <div class="comments" #scrollMe [scrollTop]="scrollMe.scrollHeight">
       @for (c of comments; track c) {
          <div class="comment font">
          <!--<img class="commentImg" style = "width: 50px; margin-top: 15px;" src="{{c.userId.profileImagePath}}" alt="comment image">-->
            <span class="headerText" style="display: inline-block; top: 4px; vertical-align: middle;">
              <div>
                <div class = "col-12" style = "top: 5px;">
                  {{c.userId?.firstName}} {{c.userId?.lastName}}
                </div>
                <div class = "col-12" style = "top: 3px;">
                  <span style = "color: #799ACF;font-family: Lato, 'Alegreya Sans'; font-size: 13.5px;">{{c.userId?.email}}</span>
                </div>
              </div>
            </span>
            <span style="float: right; margin: 7px; font-size: 12.5px">{{formatDate(c.time, 'dd/MM/yyyy hh:mm', 'en')}}</span><br>
            <div style="margin: 10px; top: -11px; font-size: 15.5px; color: #0E0D35; opacity: 0.5;">{{c.text}}</div>
          </div>
        }
      </div>
    </div>
  </div>
}

  <!-- DOKUMENTI -->
  <div class = "row" [style.display]="displayDocuments" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px;">
    <div class="documents">
      <div class="row" style = "margin: auto;">
        <!--<div class = "col-12 col-sm-6" style = "margin-top: 3%;">
          <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
              <mat-expansion-panel-header style = "padding: 15px;">
                <div class="font1"><span style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                {{labels.lblAdminDocs}}</span></div>
              </mat-expansion-panel-header>
              @if (canDownloadTest && (training.testResults == true)) {
                <div class="document">
                  <div class="documentDiv">
                    <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                    <span class="aligned-with-icon font headerText"> {{labels.lblTestResults}}</span>
                  </div>
                  <button mat-button class="buttonDocument"
                    (click)="downloadTestResults(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                  </div>
                }
                @if (canDownloadSurvey && (training.surveyResults == true)) {
                  <div class="document">
                    <div class="documentDiv">
                      <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                      <span class="aligned-with-icon font headerText"> {{labels.lblSurveyResults}} </span>
                    </div>
                    <button mat-button class="buttonDocument"
                      (click)="downloadSurveyResults(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "doc icon"></button>
                    </div>
                  }
                  @if (canDownloadStatement) {
                    <div class="document">
                      <div class="documentDiv">
                        <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                        <span class="aligned-with-icon font headerText"> {{labels.lblStatement}} </span>
                      </div>
                      <button mat-button class="buttonDocument"
                        (click)="downloadStatement(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "doc icon"></button>
                      </div>
                    }
                    @if ((canDownloadStatement == false) && (canDownloadSurvey == false) && (canDownloadTest == false)) {
                      <div style = "margin-top: 15px; margin-left: 7px;">
                        <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}} </span>
                      </div>
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </div>-->
              <div class = "col-12 col-sm-6" style = "margin-top: 3%;">
                <mat-accordion class="example-headers-align" multi>
                  <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
                    <mat-expansion-panel-header style = "padding: 15px;">
                      <div class="font1"><span style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                      {{labels.lblTrainingDocs}}</span></div>
                    </mat-expansion-panel-header>

                    @if (canDownloadTest && (training.testResults == true)) {
                      <div class="document">
                        <div class="documentDiv">
                          <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                          <span class="aligned-with-icon font headerText"> {{labels.lblTestResults}}</span>
                        </div>
                        <button mat-button class="buttonDocument"
                                (click)="downloadTestResults(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "Doc icon"></button>
                      </div>
                    }
                    @if (canDownloadCertificate && training.certificateFlag) {
                      <div class="document">
                        <div class="documentDiv">
                          <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                          <span class="aligned-with-icon font headerText"> {{labels.lblCertificate}} </span>
                        </div>
                        <button mat-button class="buttonDocument"
                                (click)="downloadCertificate(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "doc icon"></button>
                      </div>
                    }
                    <!--@if (canDownloadStatement) {
                      <div class="document">
                        <div class="documentDiv">
                          <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                          <span class="aligned-with-icon font headerText"> {{labels.lblStatement}} </span>
                        </div>
                        <button mat-button class="buttonDocument"
                                (click)="downloadStatement(training._id)"><img src = "./assets/icons/docIconBlue.png" alt = "doc icon"></button>
                      </div>
                    }-->
                    @if ((canDownloadSurvey == false) && (canDownloadTest == false)) {
                      <div style = "margin-top: 15px; margin-left: 7px;">
                        <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}}
                          <a href="https://intranet.rgz.local/intranet/TemplateStandard.aspx?pageID=1667">https://intranet.rgz.local/intranet/TemplateStandard.aspx?pageID=1667</a></span>
                      </div>
                    }

                    @for (document of trainingDocuments; track document) {
                      <div class="document">
                        <div class="documentDiv">
                          <!-- <mat-icon style="color: #0E0D35; vertical-align: middle;"> attach_file</mat-icon> -->
                          <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                          <span class="aligned-with-icon font headerText1"> {{document.docName}} </span>
                        </div>
                        <a class="link" target="_blank" href={{document.docPath}}
                          cdkFocusInitial><img src = "./assets/icons/docIconBlue.png" alt = "Doc icon"></a>
                        </div>
                      }
                      @if (trainingDocuments.length == 0) {
                        <!--<div style = "margin-top: 15px; margin-left: 7px;">
                          <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}} </span>
                        </div>-->
                      }

                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <!--<div class = "col-12 col-sm-6" style = "margin-top: 3%;">
                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel class="expansionPanel" style = "padding: 0px;">
                      <mat-expansion-panel-header style = "padding: 15px;">
                        <div class="font1"><span style="display:table-cell; vertical-align: middle; padding-left: 10px; font-size: 21px; font-weight: bold;">
                        {{labels.lblAdditionalDocs}}</span></div>
                      </mat-expansion-panel-header>

                      <div>
                        @for (document of userDocuments; track document) {
                          <div class="document">
                            <div class="documentDiv">
                              <span><img src = "./assets/icons/attachmentIcon.png" alt = "attachment icon"></span>
                              <span class="aligned-with-icon font headerText"> {{document.name}} </span>
                            </div>
                            <a class="link" target="_blank" href={{document.path}}
                              cdkFocusInitial><img src = "./assets/icons/docIconBlue.png" alt = "doc icon"></a>
                            </div>
                          }
                          @if (userDocuments.length == 0) {
                            <div style = "margin-top: 15px; margin-left: 7px;">
                              <span class="aligned-with-icon font headerText1"> {{labels.lblNoDocuments}} </span>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>-->
                </div>

              </div>
            </div>

            <!-- DOKUMENT LEKCIJA -->
            <!-- <div [style.display]="displayDocumentsUnit" *ngIf = "currentUnit.documentPath != null" style = "margin-top: 5%; border-bottom: none;">
            <div class="document docUnit" style = "border-bottom: none;">
              <div class="documentDiv" style = "border-bottom: none;">
                <span><img src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webIcons%2FattachmentIcon.png?alt=media&token=f70e7e54-2df5-4fa1-8e19-53061f8e6b58"></span>
                <span class="aligned-with-icon font headerText"> {{labels.lblDocument}} </span>
              </div>
              <a class="link" target="_blank" href="{{documentPath}}" (click) = "docDownloaded()"
                cdkFocusInitial><img src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webIcons%2FdocIconBlue.png?alt=media&token=b5d5bff5-dd69-4b75-9389-ea2a1bea1247"></a>
              </div>
            </div>
            -->
            <!-- OBLASTI -->
            <div class = "row" style = "width: 100%; margin: auto; margin-top: 3%; padding-top: 25px;">
              <div style = "width: 100%;"  [style.display]="displaySections">
                @for (section of training.sections; track section) {
                  <div class = "col-12 col-sm-6" style = "padding: 0px;">
                    <mat-accordion class="example-headers-align" multi>
                      <mat-expansion-panel style="width: 95%; margin: auto; margin-top: 10px; padding-top: 5px; padding-bottom: 5px;" class = "expansionPanel">
                        <mat-expansion-panel-header>
                          <div class="sectionName font"><span
                            style="display:table-cell; padding-left: 10px; line-height: 30px; padding: 10px;">
                          {{section.name}}</span></div>
                        </mat-expansion-panel-header>
                        @for (unit of section.units; track unit) {
                          <div [class.current]="isCurrent(unit._id)"
                            class="unitName font" (click)="onUnitClick(unit)" style = "padding: 15px;">
                            <span [class.navyColor] = "getIconClass(unit._id)" [class.greyColor] = "!getIconClass(unit._id)"
                              style="width: 80%; vertical-align: middle; margin: 10px; float: left;">
                              <span style = "vertical-align: bottom;">
                                @if (getIconClass(unit._id)) {
                                  <img style = "width: 20px;" src = "./assets/icons/playCircleIcon.png" alt = "unit icon">
                                }
                                @if (!getIconClass(unit._id)) {
                                  <img style = "width: 20px;" src = "./assets/icons/lockIcon.png" alt = "unit icon">
                                }
                              </span>
                            {{unit.name}}</span>
                            <span style = "margin: 10px; float: right;">
                              @if (getIconClass(unit._id)) {
                                <img style = "width: 20px;" src = "./assets/icons/unitIconNavy.png" alt = "unit icon">
                              }
                              @if (!getIconClass(unit._id)) {
                                <img style = "width: 20px;" src = "./assets/icons/unitIconGrey.png" alt = "unit icon">
                              }
                            </span>
                          </div>
                        }
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                }
              </div>
            </div>
          </div>

        <!-- mobile -->
        <div style = "display: none;">
          <div class="row" style="width: 100%; background-color: rgb(244, 248, 249); margin-left: 0px;">
            <div class="col-12">
              <h2 style="margin-top: 15px; margin-bottom: 15px; float: left; color: black;font-family: Lato, 'Alegreya Sans';">
              {{currentUnit.name}}</h2>
              @if (showControl == true) {
                <h2 style="margin-top: 15px; margin-bottom: 15px; float: left; color: black;font-family: Lato, 'Alegreya Sans';">
                {{labels.lblControlQuestion}}</h2>
              }
            </div>
          </div>
          <div>
            <div [style.background-color] = "backgroundColor" style="height:30%; text-align: center;">
              <div style="width:100%; float: left; text-align: left; padding-left: 25px;">
                @if (user.companyId == 1) {
                  <img src={{labels.backBtnPath1}}
                    style="width: 100px; height: 90px; cursor: pointer;" (click)="goToTrainingDetails(training)" alt = "back button icon">
                }
                @if (user.companyId != 1) {
                  <img src={{labels.backBtnPath}}
                    style="width: 100px; height: 90px; cursor: pointer;" alt = "Back button icon" (click)="goToTrainingDetails(training)">
                }</div>
                <div class="trainingName font">{{training.name}}</div>
                <div class="progresValue font">{{progress}}% {{labels.lblCompleted}}</div>
              </div>
              <div class="progress" [style.width]="progress+'%'"></div>
            </div>
            <div>
              @if (showControl == true) {
                <div class="testQuestion" [class]="controlClass">
                  <h2 class="questionText">
                    {{currentUnit.controlQuestions[0].text}}
                  </h2>
                  @for (answer of currentUnit.controlQuestions[0].answers; track answer) {
                    <div class="answer"
                      [class.answerSelected]='answer.selected'>
                      <mat-checkbox [value]="answer._id" class="checkBox" [(ngModel)]="answer.selected"
                        (change)="onSelect(currentUnit.controlQuestions[0], answer);">
                        {{answer.textAns1}}
                      </mat-checkbox>
                    </div>
                  }
                  <div>
                    @if (checked == true) {
                      <button mat-raised-button class="button"
                        (click)="submit(currentUnit.controlQuestions[0])" style="float: right;">
                        {{labels.lblSubmit}}
                      </button>
                    }
                  </div>
                </div>
              }
              @if ((currentUnit.imagePath != null) && (showControl == false)) {
                <div class="imgCls" style="width: 100%; height: 70vh">
                  <img src={{imagePath}} alt = "unit image" style="margin: auto; width: 100%; height: 100%;  object-fit: contain;">
                </div>
              }
              @if (currentUnit.videoPath != null) {
                <div class="mobPlayerContainer" [class]="playerClass" style="position: relative; margin-top:3vh;" (click)="playPauseVideo()">
                  @if (showVideo == true) {
                    <div class="arrowContainer">
                      <div class={{arrowBackClass}} (click)="onPreviousVideo()">
                        <mat-icon [inline]="true">arrow_back_ios</mat-icon>
                      </div>
                      <!-- <div class="playPuseBtn" (click)="playPauseVideo()">
                      <img class="continueBtn1" style="padding-bottom: 25px;" src={{labels.playButton}}>
                    </div> -->
                    <div class="arrowForward" (click)="onNextVideo()">
                      <mat-icon [inline]="true">arrow_forward_ios</mat-icon>
                    </div>
                  </div>
                }
                <video id="my-video" #player controls width="100%" height="100%" src={{videoPath}} type="video/mp4"
                  (ended)="onVideoFinished()" (play)="setPauseIcon()" (pause)="setPlayIcon()" controlsList="noplaybackrate nodownload"
                  (seeking)="onSeeking()" (timeupdate)="onTimeUpdate()">
                </video>
              </div>
            }
            @if (currentUnit.audioPath != null) {
              <div style="margin-bottom: 15px;">
              </div>
            }
            <div class="row">
              @if (currentUnit.documentPath != null) {
                <div class="col-11" style="width: 100%; height: 100%;font-family: Lato, 'Alegreya Sans'; padding: 11px; padding-bottom: 0px;">
                  <a class="document" href="{{documentPath}}" target="_blank"><mat-icon style="vertical-align: middle;">file_download</mat-icon>Dokument</a>
                </div>
              }
            </div>
            @if (currentUnit.text != null) {
              <div style="margin-bottom: 15px;">
                <div class="textUnit" style="width: 100%; height: 100%;font-family: Lato, 'Alegreya Sans'; padding: 11px; padding-left: 20px;">{{text}}</div>
              </div>
            }


            @if ((showControl == false) && (currentUnit.videoPath == null)) {
              <div class="row" style="width: 100%; margin-top: 5%;">
                <div class="col-6" style="padding-left: 3%;">
                  <button (click) = "onPreviousVideo()" style="padding: 7px; font-family: 'Poppins'; color: rgb(241,106,100); background-color: transparent; border: 1px solid rgb(241,106,100); border-radius: 5px; width: 110px;">{{labels.lblBack}}</button>
                </div>
                @if ((currentUnit.audioPath == null) && (currentUnit.documentPath == null)) {
                  <div class="col-6" style="text-align: right; padding-right: 3%;">
                    <button [class] = "buttons" (click) = "onNextVideo2()" style="padding: 7px; font-family: 'Poppins'; border-radius: 5px; width: 110px;">{{labels.lblContinue}}</button>
                  </div>
                }
                @if (currentUnit.audioPath != null) {
                  <div class="col-6" style="text-align: right; padding-right: 3%;">
                    <button [class] = "buttons" (click) = "onNextVideo3(1)" style="padding: 7px; font-family: 'Poppins'; border-radius: 5px; width: 110px;">{{labels.lblContinue}}</button>
                  </div>
                }
                @if (currentUnit.documentPath != null) {
                  <div class="col-6" style="text-align: right; padding-right: 3%;">
                    <button [class] = "buttons" (click) = "onNextVideo3(2)" style="padding: 7px; font-family: 'Poppins'; border-radius: 5px; width: 110px;">{{labels.lblContinue}}</button>
                  </div>
                }
              </div>
            }
            <div class="mobUnits">
              @if (status == 3) {
                <div style = "width: 99%; text-align: center; margin: auto">
                  <button class="button" style = "width: 100%; text-align: center; padding: 10px; margin-top: 10px; font-size: 3.7vh; border: 1px solid rgb(241,106,100); border-radius: 3px;" (click) = "openTestDialog()">{{labels.lblTest}}</button>
                </div>
              }
              @for (section of training.sections; track section) {
                <div class="section">
                  <mat-accordion class="example-headers-align" multi>
                    <mat-expansion-panel style="padding-top: 10px; width: 100%;">
                      <mat-expansion-panel-header style="height: 100% !important; width: 100%; margin-top: 15px;">
                        <div class="sectionName font"><span
                          style="display:table-cell; vertical-align: middle; padding-left: 10px; line-height: 33px;">{{section.order}}.
                        {{section.name}}</span></div>
                      </mat-expansion-panel-header>
                      @for (unit of section.units; track unit) {
                        <div [class.current]="isCurrent(unit._id)"
                          class="unitName font" (click)="onUnitClick(unit)">
                          <span
                            style="display:table-cell; vertical-align: middle; padding-left: 10px;"><span>{{section.order}}.{{unit.order}}.</span>
                          {{unit.name}}</span>
                        </div>
                      }
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              }
            </div>
            <div class="cardsContainer col-xs-12" style="margin-top:3vh; padding-left:0 !important;">
              <app-user-cards></app-user-cards>
            </div>
          </div>
        </div>
      </div>

        <script src="https://vjs.zencdn.net/7.8.4/video.js"></script>
      </mat-drawer-content>
    </mat-drawer-container>
